import $ from 'jquery';
/**
 * Enables the "navigation bar" functionality.
 */
const enableNavigationBarFunctionality = () => {
    if ($('#navigation-bar').length === 0) {
        return;
    }
    /**
     * The current path.
     */
    const currentPath = _trimQuerystring(window.location.pathname);
    // Highlight the link in the navigation bar that corresponds to the current path
    $('#navigation-bar .nav-item').each(function () {
        const $item = $(this);
        const $link = $('.nav-link', $item);
        if (currentPath === _trimQuerystring($link.attr('href') || '')) {
            $item.addClass('active');
        }
    });
    /**
     * Trims a URL of its query string.
     * @param url - The URL.
     * @returns The trimmed URL.
     */
    function _trimQuerystring(url) {
        return url.replace(/\?.*$/, '');
    }
};
export default enableNavigationBarFunctionality;
